// export const sensorIcons = [
//     {
//         dotBlue: {
//             url: '/assets/sensors/dot-blue.svg',
//             scaledSize: new google.maps.Size(30, 30)
//         },
//     },
//     {
//         dotGreen: {
//             url: '/assets/sensors/dot-green.svg',
//             scaledSize: new google.maps.Size(30, 30)
//         },
//     },
//     {
//         dotGrey: {
//             url: '/assets/sensors/dot-grey.svg',
//             scaledSize: new google.maps.Size(30, 30)
//         },
//     }
// ];

export const sensorIcons = {
    dotBlue: {
        url: '/assets/sensors/dot-blue.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dotGreen: {
        url: '/assets/sensors/dot-green.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dotGrey: {
        url: '/assets/sensors/dot-grey.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dotOrange: {
        url: '/assets/sensors/dot-orange.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dotRed: {
        url: '/assets/sensors/dot-red.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dotYellow: {
        url: '/assets/sensors/dot-yellow.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dswBlue: {
        url: '/assets/sensors/dsw-blue.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dswGreen: {
        url: '/assets/sensors/dsw-green.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dswGrey: {
        url: '/assets/sensors/dsw-grey.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dswOrange: {
        url: '/assets/sensors/dsw-orange.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dswRed: {
        url: '/assets/sensors/dsw-red.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    dswYellow: {
        url: '/assets/sensors/dsw-yellow.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    plainBlue: {
        url: '/assets/sensors/plain-blue.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    plainGreen: {
        url: '/assets/sensors/plain-green.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    plainGrey: {
        url: '/assets/sensors/plain-grey.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    plainOrange: {
        url: '/assets/sensors/plain-orange.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    plainRed: {
        url: '/assets/sensors/plain-red.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    plainYellow: {
        url: '/assets/sensors/plain-yellow.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    soneBlue: {
        url: '/assets/sensors/sone-blue.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    soneGreen: {
        url: '/assets/sensors/sone-green.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    soneGrey: {
        url: '/assets/sensors/sone-grey.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    soneOrange: {
        url: '/assets/sensors/sone-orange.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    soneRed: {
        url: '/assets/sensors/sone-red.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    inclinometer_xBlue: {
        url: '/assets/sensors/inclinometer_x-blue.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    inclinometer_xGreen: {
        url: '/assets/sensors/inclinometer_x-green.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    inclinometer_xGrey: {
        url: '/assets/sensors/inclinometer_x-grey.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    inclinometer_xOrange: {
        url: '/assets/sensors/inclinometer_x-orange.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    inclinometer_xRed: {
        url: '/assets/sensors/inclinometer_x-red.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    locationGreen: {
        url: '/assets/locations/location-green.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    locationOrange: {
        url: '/assets/locations/location-orange.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    locationRed: {
        url: '/assets/locations/location-red.svg',
        scaledSize: new google.maps.Size(30, 30)
    },
    locationGrey: {
        url: '/assets/locations/location-grey.svg',
        scaledSize: new google.maps.Size(30, 30)
    },

    get icon() {
        return 'test';
    },

    getIcon: function (icon) {
        console.log(this);

        return this.icon;
    }

};
